module.exports = __webpack_public_path__ + "static/media/6-10.978716c9.mp3";